module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid52_980x886.b8150fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid52_980x886.jpg
// module id = 2Y8D
// module chunks = 0